import { removeAccents } from './common/utils';
import HighlightText from './ui';

export { removeAccents };
export default HighlightText;
